export var formatPrice = function formatPrice(price) {
  if (price === 0 || price === '0' || price === null) return price;
  var newPrice = Number(price);
  return new Intl.NumberFormat('sv-SE', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 4,
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 8
  }).format(newPrice);
};